import React from 'react';
import { TextStyled } from '@nike/nike-design-system-components';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const SecEmeaCutoverUS = () => (
  <div style={{ paddingBottom: '10px', marginBottom: '12px' }}>
    <TextStyled bold appearance='body1'>
      <TranslatedCopy id='termsConditions.section.notice' />
    </TextStyled>
    <TextStyled>
      <TranslatedCopy id='outages.systemUpgrade.notice' />
    </TextStyled>
    <br />
    <TextStyled bold style={{ textDecoration: 'underline' }}>
      <TranslatedCopy id='outages.systemUpgrade.users.emea' />
    </TextStyled>
    <TextStyled bold display='inline'>
      December 28, 3-7pm PST
    </TextStyled>
    <TextStyled display='inline'> - Full Site Outage</TextStyled>
    <br />
    <TextStyled>There will be no access to the GAMEDAY site during this time.</TextStyled>
    <br />
    <TextStyled bold style={{ textDecoration: 'underline' }}>
      US Users ONLY:
    </TextStyled>
    <TextStyled bold display='inline'>
      December 29, 3am PST
    </TextStyled>
    <TextStyled>Shop & Returns will be disabled. Users can continue to access Account Information.</TextStyled>
    <TextStyled bold display='inline'>
      Dec 31
    </TextStyled>
    <TextStyled>Site functionality returns to normal</TextStyled>
    <br />
  </div>
);

export default SecEmeaCutoverUS;
